import apiClient from './apiClient';

const MATERIALS_DATABASE = 'materialdatabase';
const MATERIALS_COLLECTION = 'materialData';
const MATERIALS_BASE_PATH = `/materials/${MATERIALS_DATABASE}/${MATERIALS_COLLECTION}`;

export const getMaterialBySlug = async (slug) => {
  const response = await apiClient.get(`${MATERIALS_BASE_PATH}/slug/${encodeURIComponent(slug)}`);
  return response.data;
};

export const getMaterials = async ({ page, limit }) => {
  const response = await apiClient.get(MATERIALS_BASE_PATH, {
    params: { page, limit },
  });

  return response.data;
};

export const searchMaterials = async ({ page, limit, searchString }) => {
  const response = await apiClient.get(`${MATERIALS_BASE_PATH}/search`, {
    params: { page, limit, searchString },
  });

  return response.data;
};
export const findMaterials = async (criteria) => {
  const response = await apiClient.post('/materials/finder', criteria);

  return response.data;
};


export const createMaterial = async (materialData) => {
  const response = await apiClient.post(MATERIALS_BASE_PATH, materialData);

  return response.data;
};

export const updateMaterial = async (materialId, updates) => {
  const response = await apiClient.put(
    `${MATERIALS_BASE_PATH}/${materialId}`,
    updates
  );

  return response.data;
};

export const deleteMaterial = async (materialId) => {
  const response = await apiClient.delete(`${MATERIALS_BASE_PATH}/${materialId}`);

  return response.data;
};

export const getDeletedMaterials = async () => {
  const response = await apiClient.get(`${MATERIALS_BASE_PATH}/trash`);
  return response.data;
};

export const restoreMaterial = async (materialId) => {
  const response = await apiClient.post(`${MATERIALS_BASE_PATH}/${materialId}/restore`);
  return response.data;
};
